module.exports = __webpack_public_path__ + "593a3d53/img/trash-icon.ff8201c7.svg";